import { LUCKY_WHEEL_LEVEL_UNLOCK, LUCKY_WHEEL_START_LEVEL, LUCKY_WHEEL_SPAWN_INCREMENT } from "Constants/LuckyWheel";
import { FTUXType } from "Player/PlayerProperty/Progress/FTUXType";
import { FTUXStateHelper } from "State/Game/FTUX/FTUXStateHelper";
import { WorldDataHelper } from "Utility/WorldDataHelper";
import { IPlayerState } from "../IPlayerState";
import { getCurrentLevelNumber, getHighestLevelCompleted } from '../PlayerLevelHelper';
import { PlayerStateHelper } from "../PlayerStateHelper";
import { PlayerTask } from "../PlayerTasks";

export namespace LuckyWheelStateHelper {
    export const getLuckyWheelLevels = (lastClaimedSpinLevel: number, lastWorldLevel: number): number[] => {
        const luckyWheelNodes = [];
        let nextLevelNumber = Math.max(LUCKY_WHEEL_START_LEVEL, (lastClaimedSpinLevel || 0));

        while (nextLevelNumber <= lastWorldLevel) {
            if (nextLevelNumber > lastClaimedSpinLevel) {
                luckyWheelNodes.push(nextLevelNumber);
            }

            nextLevelNumber += LUCKY_WHEEL_SPAWN_INCREMENT;
        }

        return luckyWheelNodes;
    }

    export const getEligibleWheelLevels = (lastClaimedSpinLevel: number, lastWorldLevel: number, highestLevelCompleted: number): number[] => {
        return getLuckyWheelLevels(lastClaimedSpinLevel, lastWorldLevel)
            .filter((wheelLevelNumber) => {
                return wheelLevelNumber > highestLevelCompleted;
            });
    }

    // helpers    
    export function queueWheelFTUXIfNeeded(
        playerState: IPlayerState
    ): IPlayerState {
        const highestLevelCompleted = getHighestLevelCompleted(playerState);
        const currentWorldNumber = WorldDataHelper.getWorldNumber(highestLevelCompleted);
        const currentWorldNumberAdjusted = WorldDataHelper.getWorldNumber(highestLevelCompleted + 1);

        if (currentWorldNumber !== currentWorldNumberAdjusted) return playerState;
        const luckyWheelLevels
            = getEligibleWheelLevels(playerState.lastClaimedSpinLevel, WorldDataHelper.maxLevel(currentWorldNumber), highestLevelCompleted);

        if (
            highestLevelCompleted >= LUCKY_WHEEL_LEVEL_UNLOCK &&
            !FTUXStateHelper.isFtuxCompleted(playerState, FTUXType.LUCKY_WHEEL) &&
            luckyWheelLevels.length > 0 &&
            luckyWheelLevels[0] !== playerState.petLevel &&
            playerState.tasks.find(task => task.task === PlayerTask.WHEEL_FTUX) === undefined
        ) {
            return PlayerStateHelper.addStateTaskDatas(playerState, [
                {
                    task: PlayerTask.WHEEL_FTUX,
                    firstWheelLevel: luckyWheelLevels[0],
                },
            ]);
        }
        return playerState;
    }

    export function checkEligibility(state: IPlayerState): boolean {
        const currentLevel = getCurrentLevelNumber(state);
        const worldNumber = WorldDataHelper.getWorldNumber(currentLevel);
        const wheelLevels = LuckyWheelStateHelper.getLuckyWheelLevels(state.lastClaimedSpinLevel, WorldDataHelper.maxLevel(worldNumber));
        return (wheelLevels.includes(currentLevel) && currentLevel > state.lastClaimedSpinLevel);
    }
}
